import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    moduleGroups: [],
    modelDefault: {
        id: null,
        title: 'Название',
        bot_id: null,
        bot_type_bit: 0,
        module_ids: null,
        structure: null,
        type: 0,
        status: 0,
        visible: 1
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
